import { languageToCode, isNewShop } from "./languageUtils";

interface SalesOrganization {
  shop_url: string;
  store_id: number;
  country: string;
}

const getBaseUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return `${urlObj.protocol}//${urlObj.hostname}`;
  } catch {
    return "";
  }
};

export const constructShoppingUrl = (
  data: any,
  language: "nl" | "en" | "fr" | "de",
  erpSystem: string,
  loginUrl?: string
) => {
  const isNew = isNewShop(loginUrl);

  if (isNew && loginUrl) {
    const baseUrl = getBaseUrl(loginUrl);
    if (!baseUrl) return "/";
    return `${baseUrl}/${erpSystem.toLowerCase()}/${language}/cart`;
  }

  if (!data || !Array.isArray(data) || data.length === 0) return "/";
  const salesOrganization: SalesOrganization | undefined = data.find(
    (org: SalesOrganization) => org.country === erpSystem.toUpperCase()
  );
  if (!salesOrganization) return "/";
  return `${
    salesOrganization.shop_url
  }ShoppingCartDisplay?catalogId=1000&langId=${languageToCode(
    language
  )}&storeId=${salesOrganization.store_id}`;
};
